export default "__VITE_ASSET__ChILBNvr__"